import React from 'react'
import { HideMediaIcon, ShowMediaIcon } from './MediaIcon'

interface MediaActionProps {
  isShowMedia: boolean
  setIsShowMedia: React.Dispatch<React.SetStateAction<boolean>>
}
const MediaController = ({ isShowMedia, setIsShowMedia }: MediaActionProps) =>
  isShowMedia ? (
    <HideMediaIcon callback={() => setIsShowMedia(false)} />
  ) : (
    <ShowMediaIcon callback={() => setIsShowMedia(true)} />
  )

export default MediaController
